import * as types from '../mutation-types'

export default {
	namespaced: true,

	state: {
		visits: []
	},

	actions: {
		fetchAll({ commit }, { employeeId, entityIds, regionIds, paymentStatuses, page, perPage } = {}) {
			return window.axios.get('/Visits/DebtVisit', {
				params: { employeeId, entityIds, regionIds, paymentStatuses, Page: page, PerPage: perPage },
				// entityIds/regionIds/paymentStatuses are collectionFormat:multi - axios' default `ids[]=` form
				// is not bound by the API and the filter is silently ignored otherwise
				paramsSerializer: { indexes: null }
			}).then(({ data }) => {
				commit(types.STORE_DEBT_VISITS, data || [])
				return data
			})
		},

		modifyAmountReceived({ commit }, { id, amountReceived }) {
			// المبلغ يُرسل كجسم JSON مجرّد؛ axios يُسلسل الكائنات فقط، فالرقم المفرد كان
			// ينطلق بـ text/plain ويرفضه الـ API - الترويسة تجبره على الذهاب كـ request payload
			const configs = { headers: { 'Content-Type': 'application/json' } }

			return window.axios.put(`/Visits/${id}/ModifyVisitAmountReceived`, amountReceived, configs)
				.then((response) => {
					commit(types.UPDATE_DEBT_VISIT_AMOUNT_RECEIVED, { id, amountReceived })
					return response.data
				})
		},

		reset({ commit }) {
			commit(types.RESET_DEBT_VISITS)
		}
	},

	mutations: {
		[types.STORE_DEBT_VISITS](state, visits) {
			state.visits = visits
		},

		[types.UPDATE_DEBT_VISIT_AMOUNT_RECEIVED](state, { id, amountReceived }) {
			const visit = state.visits.find(c => c.id === id)
			if (visit) visit.amountReceived = amountReceived
		},

		[types.RESET_DEBT_VISITS](state) {
			state.visits = []
		}
	}
}
